import { render } from "./ReminderMessagePage.vue?vue&type=template&id=6e418e34&scoped=true"
import script from "./ReminderMessagePage.vue?vue&type=script&lang=js"
export * from "./ReminderMessagePage.vue?vue&type=script&lang=js"

import "./ReminderMessagePage.vue?vue&type=style&index=0&id=6e418e34&lang=css"
import "./ReminderMessagePage.vue?vue&type=style&index=1&id=6e418e34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e418e34"]])

export default __exports__